import {useQuery} from '@tanstack/react-query';
import {rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {RQ_GET_HOSPITAL_REPORT_API} from '@app/reactQuery/apis/constants';

export const RQUseGetHospitalReportData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_hospital_report_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_HOSPITAL_REPORT_API,
        null,
        certificate,
        {divisionId: divisionId},
        signal,
      );
    },
    ...options,
  });
};
